import React, { useState } from 'react';
import { Modal, FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import axios from "axios";

const AwardLevelModal = ({ isOpen, toggle, awardLevel, handleAssign, eventId,organizationId, programId}) => {
    const [formData, setFormData] = useState({
        id: 0,
        event_id: eventId,
        amount: "",
        award_level_id: awardLevel.id
    });

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        if (name === 'amount') {
            const isValid = /^\d+(\.\d{1,2})?$/.test(value); // Проверяем, является ли значение числом с двумя знаками после запятой
            setErrors({ ...errors, [name]: isValid ? '' : 'Amount must be a number with up to two decimal places' });
        }
    };

    const save = (data) => {
        axios.put(`/organization/${organizationId}/program/${programId}/event-award-level/${eventId}`, data)
            .then((res) => {
                handleAssign(data);
            }).catch((err) => {});
    };

    const handleSubmit = () => {
        if (Object.values(errors).every(error => error === '')) {
            formData.event_id = eventId;
            formData.award_level_id = awardLevel.id;
            save(formData);
        }
    };

    return (
        <Modal
            className="manager-program-settings-dialog manager-program-settings-dialog--form modal-md"
            isOpen={isOpen}
            toggle={toggle}
            centered
        >
            <div className="manager-program-settings-dialog__header">
                <div className="manager-program-settings-dialog__header-copy">
                    <h4 className="manager-program-settings-dialog__title">
                        Assign award level
                    </h4>
                    <p className="manager-program-settings-dialog__description">
                        Set the amount for {awardLevel.name}.
                    </p>
                </div>
                <button
                    type="button"
                    className="manager-program-settings-dialog__close"
                    onClick={toggle}
                    aria-label="Close"
                >
                    Close
                </button>
            </div>
            <div className="manager-program-settings-dialog__body">
                <FormGroup>
                    <Label for="amount">Amount</Label>
                    <Input
                        type="text"
                        name="amount"
                        id="amount"
                        value={formData.amount}
                        onChange={handleChange}
                        invalid={errors.amount !== ''}
                    />
                    <FormFeedback>{errors.amount}</FormFeedback>
                </FormGroup>
                <div className="manager-program-settings-dialog__actions">
                <button
                    type="button"
                    className="manager-program-settings-dialog__action is-primary"
                    onClick={handleSubmit}
                >
                    Assign
                </button>
                <button
                    type="button"
                    className="manager-program-settings-dialog__action"
                    onClick={toggle}
                >
                    Cancel
                </button>
                </div>
            </div>
        </Modal>
    );
};

export default AwardLevelModal;
